import { getMobileOperatingSystem } from 'helpers/getMobileOperatingSystem'

import { PlatformOS } from 'root-constants'

export const checkOpenInAppLinkAvailability = () => {
  const OS = getMobileOperatingSystem()
  return OS !== PlatformOS.UNKNOWN
}
